module.exports = __webpack_public_path__ + "static/media/footer_logo_bankpopulaire.fb9cb870.jpg";